import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Event, NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { select, Store } from '@ngrx/store';
import { MessageService } from 'primeng/api';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { MasterDataService } from './shared/master-data.service';
import * as fromSettings from './shared/state/setting.reducer';
import { AppState } from './state/app.state';
import { SpinnerService } from './ui/spinner.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit {
  msgs: any[];
  title = 'BTV-SyBi';
  loading = false;
  errorMessage$: Observable<string>;

  watermark = environment.watermark.toString();

  faSpinner = faSpinner;

  constructor(private router: Router, private spinnerService: SpinnerService,
    private store: Store<AppState>, private messageService: MessageService,
    private masterDataService: MasterDataService) {
    this.router.events.subscribe((routerEvent: Event) => {
      this.checkRouterEvent(routerEvent);
    });
  }

  ngOnInit() {
    this.spinnerService.connect().subscribe((state) => this.loading = state);
    this.errorMessage$ = this.store.pipe(select(fromSettings.getError));

    // The settings-Load trigger now lives in `SettingsEffects.loadSettingsOnLogin$`,
    // which dispatches `Load` whenever a non-empty user is set in the app
    // state (login, restore from localStorage). All this component has to
    // do is surface load errors as toasts.
    this.errorMessage$.subscribe(
      err => {
        if (err !== '') {
          this.messageService.add({ severity: 'error', summary: 'Einstellungen konten nicht geladen werden!', detail: err });
        }
      });

    // Master-data is independent of the settings flow: load both in parallel
    // and surface (but don't propagate) any failures.
    this.loadMasterData();
  }

  private async loadMasterData(): Promise<void> {
    try {
      await Promise.all([
        this.masterDataService.getCounties(),
        this.masterDataService.getLocations(),
      ]);
    } catch (err) {
      // Don't let a master-data failure block the rest of the app.
      // The settings flow runs independently via the store subscription above.
      const detail = err instanceof Error ? err.message : String(err);
      this.messageService.add({
        severity: 'warn',
        summary: 'Stammdaten konnten nicht geladen werden',
        detail,
      });
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      Array.from(document.querySelectorAll('.watermarked')).forEach(function (el: Element) {
        if (el instanceof HTMLElement) {
          el.dataset.watermark = (' ' + el.dataset.watermark + ' ').repeat(555);
        }
      });
    }, 50);
  }

  checkRouterEvent(routerEvent: Event): void {
    if (routerEvent instanceof NavigationStart) {
      this.loading = true;
    }

    if (routerEvent instanceof NavigationEnd ||
      routerEvent instanceof NavigationCancel ||
      routerEvent instanceof NavigationError) {
      this.loading = false;
    }
  }
}
